<template>
  <div class="mit-email-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Email</v-card-title>
            <v-card-subtitle class="caption">CSAIL Email Information</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="pt-5">
                <a href="https://imap.csail.mit.edu/cgi-bin/create/change" target="_blank">Email Password Management</a>
              </h3>
              <p>CSAIL email password management and spam settings</p>

              <h3 class="pt-5">
                <a href="https://inquir.csail.mit.edu/" target="_blank">INQUIR — CSAIL’s account management tool</a>
              </h3>
              <p>Manage your email forwarding and personal information, renew your supervisees’ accounts, and create email aliases.</p>

              <h3 class="pt-5">
                <a href="https://webmail.csail.mit.edu/" target="_blank">Webmail interface</a>
              </h3>
              <p>CSAIL mail access webapp</p>

              <h3 class="pt-5">
                <a href="https://lists.csail.mit.edu/cgi-bin/create/create_list.cgi" target="_blank">Mailing list</a>
              </h3>
              <p>Mailing list creation</p>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitEmailPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
